import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
        minHeight: 450
    },
    paper: {
        marginTop: theme.spacing(4)
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main
    },
    paperPadding: {
        padding: theme.spacing(3)
    },
    paperFlex: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1)
    },
    capitalized: {
        textTransform: "uppercase"
    },
    textAlignCenter: {
        textAlign: "center"
    }
}));
